var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "sharePrintModal",
        staticClass: "modal fade share-print-modal",
        attrs: {
          id: "sharePrintModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "sharePrintModalLabel",
          "aria-hidden": "true",
          "data-backdrop": "static",
          "data-keyboard": "false",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content sp-modal-content" }, [
              _c("div", { staticClass: "sp-header" }, [
                _vm._m(0),
                _vm._m(1),
                _c(
                  "button",
                  {
                    staticClass: "close d-close",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeModal },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "sp-body" },
                [
                  _c("div", { staticClass: "sp-section-label" }, [
                    _vm._v("PATIENT FIELDS"),
                  ]),
                  _c("div", { staticClass: "sp-toggle-list" }, [
                    _c(
                      "div",
                      {
                        staticClass: "sp-toggle-row",
                        class: { "sp-disabled": _vm.saving },
                      },
                      [
                        _vm._m(2),
                        _c("label", { staticClass: "sp-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.mobileNumber,
                                expression: "settings.mobileNumber",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.mobileNumber)
                                ? _vm._i(_vm.settings.mobileNumber, null) > -1
                                : _vm.settings.mobileNumber,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.mobileNumber,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "mobileNumber",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "mobileNumber",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "mobileNumber", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("mobileNumber")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "sp-slider" }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "sp-toggle-row",
                        class: { "sp-disabled": _vm.saving },
                      },
                      [
                        _vm._m(3),
                        _c("label", { staticClass: "sp-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.address,
                                expression: "settings.address",
                              },
                            ],
                            attrs: { type: "checkbox", disabled: _vm.saving },
                            domProps: {
                              checked: Array.isArray(_vm.settings.address)
                                ? _vm._i(_vm.settings.address, null) > -1
                                : _vm.settings.address,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.settings.address,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "address",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.settings,
                                          "address",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.settings, "address", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.onToggle("address")
                                },
                              ],
                            },
                          }),
                          _c("span", { staticClass: "sp-slider" }),
                        ]),
                      ]
                    ),
                  ]),
                  _c("transition", { attrs: { name: "sp-fade" } }, [
                    _vm.saveMessage
                      ? _c(
                          "div",
                          {
                            staticClass: "sp-save-feedback",
                            class: _vm.saveMessageType,
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.saveMessageType === "success"
                                    ? "check_circle"
                                    : "error"
                                )
                              ),
                            ]),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.saveMessage) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "sp-footer" }, [
                _vm._m(4),
                _c("div", { staticClass: "sp-footer-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "sp-btn-save primary-btn ripple",
                      attrs: { disabled: _vm.saving },
                      on: { click: _vm.saveSettings },
                    },
                    [
                      _vm.saving
                        ? _c("span", [
                            _c("i", { staticClass: "material-icons sp-spin" }, [
                              _vm._v("autorenew"),
                            ]),
                            _vm._v(" Saving…\n              "),
                          ])
                        : _c("span", [_vm._v("Save Changes")]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sp-header-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("share")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sp-header-text" }, [
      _c("h5", { attrs: { id: "sharePrintModalLabel" } }, [
        _vm._v("Share & Print Fields"),
      ]),
      _c("p", [
        _vm._v(
          "Choose which patient fields appear on shared & printed documents"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sp-toggle-info" }, [
      _c("span", { staticClass: "sp-icon mobile-icon" }),
      _c("div", [
        _c("div", { staticClass: "sp-name" }, [_vm._v("Mobile Number")]),
        _c("div", { staticClass: "sp-desc" }, [
          _vm._v("Show patient mobile number on shares & prints"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sp-toggle-info" }, [
      _c("span", { staticClass: "sp-icon address-icon" }),
      _c("div", [
        _c("div", { staticClass: "sp-name" }, [_vm._v("Address")]),
        _c("div", { staticClass: "sp-desc" }, [
          _vm._v("Show patient address on shares & prints"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "sp-footer-note" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(
        "\n            Changes apply immediately for all users on reload\n          "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }